module.exports = __webpack_public_path__ + "media/Images/icon-search-magnify-o-f5db9b8ff558ec22555973c2ab6ce42c.svg";